import { createContext } from 'react';

import { defaultOptions } from '../default-options';
import type { OptionsType } from '../types';

export const OptionsContext = createContext<OptionsType>(defaultOptions);
